import { useEffect, useMemo, useState } from 'react'
import { IExportStatus } from '$/types'
import { useGetLatestJobStatusMutation } from 'app/services/api/jobs'

export const useRefetchJobQueue = (refetchFunc: () => void) => {
  const [jobIds, setJobIds] = useState<string[]>([])
  const [getLatestJobStatus] = useGetLatestJobStatusMutation()

  const isJobQueueActive = useMemo(() => jobIds.length > 0, [jobIds.length])

  const queueJobId = (jobId: string | number) => {
    const stringJobId = jobId.toString()

    if (!jobIds.includes(stringJobId)) {
      setJobIds([...jobIds, stringJobId])
    }
  }

  useEffect(() => {
    if (jobIds.length === 0) {
      return
    }

    const checkFunc = async () => {
      const jobIdsQueue: string[] = []

      for (const jobId of jobIds) {
        await getLatestJobStatus(jobId)
          .unwrap()
          .then((status: IExportStatus) => {
            if (
              !['success', 'error'].includes(
                status.jobStatus?.toLowerCase() ?? 'error'
              )
            ) {
              jobIdsQueue.push(jobId)
            }
          })
      }

      refetchFunc()

      if (jobIds.length != jobIdsQueue.length) {
        setJobIds(jobIdsQueue)
      }
    }

    checkFunc()
    const jobChecker = setInterval(checkFunc, 5000)

    return () => clearTimeout(jobChecker)
  }, [jobIds, getLatestJobStatus, refetchFunc])

  return { isJobQueueActive, queueJobId }
}
